import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './styles/legacy-global.css';
import './styles/material-kit-extras.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './store';
import { Provider } from 'react-redux';
import * as bootstrap from 'bootstrap';

// Components rely on the bootstrap global previously injected by
// public/assets/js script tags (data-bs-* attrs + bootstrap.Offcanvas/Modal).
// Keep exposing it until all usages are migrated to React overlays.
(window as any).bootstrap = bootstrap;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
     <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
